module.exports = __webpack_public_path__ + "img/logo1.719b9d30.png";